import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import CircularProgress from "@mui/material/CircularProgress";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import FleetWebApi from "../Api/FleetWebApi";
import { useEffect, Fragment, useState } from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import TableHead from "@mui/material/TableHead";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import ProductList from "../Configuration/ProductList";

function AddRemoveBadBatch(props) {
  const [alert, setAlert] = useState(false);
  const [submitError, setsubmitError] = useState(null);
  // const [take] = useState(10);
  // const [skip, setSkip] = useState(0);
  const [isLoaded, setIsLoaded] = useState(true); //change to false after
  const [error, setError] = useState(null);
  const [affectedRev, setAffectedRev] = useState(null);
  const [affectedFw, setAffectedFw] = useState(null);
  const [affectType, setAffectType] = useState("");
  const [affectKey, setAffectKey] = useState("");
  const [affectNote, setAffectNote] = useState("");
  const [refreshNotes, setRefreshNotes] = useState(false);
  const [deviceType, setDeviceType] = useState("");
  const affectsList = ["Revision", "Firmware"];
  const onNoteChange = (e) => setAffectNote(e.target.value);
  const onKeyChange = (e) => setAffectKey(e.target.value);
  const handleSubmit = () => {
    if (affectNote.length === 0) {
      setsubmitError("You left the 'how is this affected' section empty!");
      return;
    }
    if (
      affectType === "Revision" &&
      (affectKey.length !== 1 || !affectKey.match(/[a-z]/i))
    ) {
      setsubmitError("Revision can only be a single letter between A-Z");
      return;
    }
    if (
      affectType === "Firmware" &&
      (affectKey.length === 0 || !affectKey.match(/^(\d+.)*(\d+)$/))
    ) {
      setsubmitError("Firmware can only be numbers and periods");
      return;
    }
    submit();
  };
  const handleDeviceTypeChange = (event) => {
    setDeviceType(event.target.value);
  };
  const handleAffectTypeChange = (event) => {
    setAffectType(event.target.value);
  };

  const forceRefresh = () => {
    setRefreshNotes(!refreshNotes);
  };
  async function submit() {
    await FleetWebApi.addBadBatchNote(
      deviceType,
      affectType,
      affectKey,
      affectNote
    ).then(
      (result) => {
        setAffectNote("");
        setAffectKey("");
        setAffectType("");
        setAlert(true);
      },
      (error) => {
        setsubmitError(error.message);
      }
    );
  }
  useEffect(() => {
    setIsLoaded(false);
    setAffectedFw(null);
    setAffectedRev(null);
    FleetWebApi.getBadBatchNotes(deviceType).then(
      (result) => {
        setAffectedRev(result.affectedRev);
        setAffectedFw(result.affectedFirmware);
        setIsLoaded(true);
        setError(result.error);
      },
      (error) => {
        console.log(error);
        setIsLoaded(true);
        setError(error.message);
      }
    );
  }, [deviceType]);

  let lookupByDeviceTypeComponent = (
    <div>
      <h4>Create Note</h4>
      <Box sx={{ maxWidth: 120 }}>
        <FormControl color="primary" fullWidth focused>
          <InputLabel id="chart-select-label" color="primary">
            Device Type
          </InputLabel>
          <Select
            labelId="device-select-label"
            id="device-select"
            value={deviceType}
            label="Device Type"
            onChange={handleDeviceTypeChange}
          >
            {Object.keys(ProductList).map((product, i) => (
              <MenuItem value={product} key={i}>
                {product}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <br />
    </div>
  );
  let addAffectContainer = (
    <Fragment>
      <Grid container spacing={2}>
        <Grid item xs={6} sm={3} md={3} lg={3} xl={3}>
          {Object.keys(ProductList).includes(deviceType) ? (
            <Fragment>
              <h4>Revision/Firmware</h4>
              <Box sx={{ maxWidth: 120 }}>
                <FormControl color="primary" fullWidth focused>
                  <InputLabel id="chart-select-label" color="primary">
                    Affect Type
                  </InputLabel>
                  <Select
                    labelId="device-select-label"
                    id="device-select"
                    value={affectType}
                    label="Device Type"
                    onChange={handleAffectTypeChange}
                  >
                    {affectsList.map((affect, i) => (
                      <MenuItem className="" value={affect} key={affect + i}>
                        {affect}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Fragment>
          ) : null}
        </Grid>
        <Grid item xs={6} sm={9} md={9} lg={9} xl={9}>
          {Object.keys(ProductList).includes(deviceType) &&
          affectsList.includes(affectType) ? (
            <Fragment>
              <Paper>
                <TextField
                  id="Enter Revision or Firmware Version"
                  label={"Enter " + affectType}
                  multiline
                  minRows={5}
                  variant="filled"
                  fullWidth
                  color="secondary"
                  onChange={onKeyChange}
                  value={affectKey}
                />
              </Paper>
            </Fragment>
          ) : null}
        </Grid>
        {/* </Grid> */}
        {/* <Grid container spacing={1}> */}
        {Object.keys(ProductList).includes(deviceType) &&
        affectsList.includes(affectType) ? (
          <Fragment>
            <Grid item xs={12} sm={9} md={9} lg={9} xl={9}>
              <Paper>
                <TextField
                  id="create note"
                  label={"How is the " + affectType + " affected?"}
                  multiline
                  minRows={5}
                  variant="filled"
                  fullWidth
                  color="secondary"
                  onChange={onNoteChange}
                  value={affectNote}
                />
              </Paper>
            </Grid>
            <Grid item xs={6} sm={3} md={3} lg={3} xl={3}>
              <Button
                variant="contained"
                type="submit"
                color="primary"
                label="Add Note"
                fullWidth={true}
                size="large"
                style={{ marginTop: 38 }}
                onClick={handleSubmit}
              >
                Submit
              </Button>
              <br />
            </Grid>
          </Fragment>
        ) : null}
      </Grid>
    </Fragment>
  );
  let affectedContainer = (
    <Fragment>
      <Paper>
        {affectedRev ? (
          <Table classes={{ root: "reactivetable" }}>
            <TableHead>
              <TableRow>
                <TableCell>Affected Rev</TableCell>
                <TableCell>Note</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {affectedRev.map((revData, revKey) => (
                <TableRow key={revKey}>
                  <TableCell data-th="Rev">{revData.key}</TableCell>
                  <TableCell data-th="Note">{revData.badAffect}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : null}
      </Paper>
      <br />
      <Paper>
        {affectedFw ? (
          <Table classes={{ root: "reactivetable" }}>
            <TableHead>
              <TableRow>
                <TableCell>Affected Firmware</TableCell>
                <TableCell>Note</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {affectedFw.map((fwData, fwKey) => (
                <TableRow key={fwKey}>
                  <TableCell data-th="Firmware">{fwData.key}</TableCell>
                  <TableCell data-th="Note">{fwData.badAffect}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : null}
      </Paper>
    </Fragment>
  );
  let addSuccessfulContainer = (
    <div>
      {alert ? (
        <Alert
          severity="success"
          onClose={() => {
            setAlert(false);
            forceRefresh();
          }}
        >
          <AlertTitle>Note added successfully!</AlertTitle>
          Please close this alert to refresh the page.
        </Alert>
      ) : null}
    </div>
  );
  let addErrorContainer = (
    <div>
      {submitError ? (
        <Alert
          severity="error"
          onClose={() => {
            setsubmitError(null);
          }}
        >
          <AlertTitle>Error!</AlertTitle>
          {submitError}
        </Alert>
      ) : null}
    </div>
  );
  let notesDetailsContainer;
  if (error) {
    notesDetailsContainer = (
      <Container maxWidth="lg">
        {addErrorContainer}
        {addSuccessfulContainer}
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            {lookupByDeviceTypeComponent}
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            {addAffectContainer}
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <h4>Existing Notes</h4>
            Error: {error}
          </Grid>
        </Grid>
      </Container>
    );
    return notesDetailsContainer;
  } else if (!isLoaded) {
    return (
      <div>
        <CircularProgress color="secondary" />
      </div>
    );
  } else {
    notesDetailsContainer = (
      <Container>
        {addErrorContainer}
        {addSuccessfulContainer}

        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            {lookupByDeviceTypeComponent}
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            {addAffectContainer}
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            {affectedContainer}
          </Grid>
        </Grid>
      </Container>
    );
    return notesDetailsContainer;
  }
}

export default AddRemoveBadBatch;
